// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

	/* Boost #93442*/
    InstantSearchApi.beforeCall = function(eventType, eventInfo) {
      if (boostPFSConfig.shop.tags && boostPFSConfig.shop.tags.length > 0) {
        if (boostPFSConfig.shop.tags.includes('REFERIDO')) {
          Globals.instantSearchQueryParams = {tag: 'pfs:on-referido'};
		}
        if (boostPFSConfig.shop.tags.includes('EMPLEADO')) {
          Globals.instantSearchQueryParams = {tag: 'pfs:on-empleado'};
		}
	  }
    }
	/* Boost #93442*/
})();